"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.sync = exports.syncCoreAccount = exports.newSyncLogId = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var logs_1 = require("@ledgerhq/logs");
var errors_1 = require("@ledgerhq/errors");
var access_1 = require("./access");
var buildAccount_1 = require("./buildAccount");
var getCoreAccount_1 = require("./getCoreAccount");
var errors_2 = require("./errors");
var account_1 = require("../account");
var libcore_postSyncPatch_1 = __importDefault(require("../generated/libcore-postSyncPatch"));
var presync_1 = __importDefault(require("../generated/presync"));
var coreSyncCounter = 0;
var newSyncLogId = function () { return ++coreSyncCounter; };
exports.newSyncLogId = newSyncLogId;
function syncCoreAccount(_a) {
    var core = _a.core, coreWallet = _a.coreWallet, coreAccount = _a.coreAccount, currency = _a.currency, accountIndex = _a.accountIndex, derivationMode = _a.derivationMode, seedIdentifier = _a.seedIdentifier, existingAccount = _a.existingAccount, logId = _a.logId, syncConfig = _a.syncConfig;
    return __awaiter(this, void 0, void 0, function () {
        var presync, eventReceiver, eventBus, serialContext, account, e_1, specificError;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    presync = presync_1["default"][currency.family];
                    if (!presync) return [3 /*break*/, 2];
                    return [4 /*yield*/, presync(currency)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 9, , 10]);
                    if (!!syncConfig.withoutSynchronize) return [3 /*break*/, 7];
                    (0, logs_1.log)("libcore", "sync(".concat(logId, ") syncCoreAccount"));
                    return [4 /*yield*/, core.EventReceiver.newInstance()];
                case 3:
                    eventReceiver = _b.sent();
                    return [4 /*yield*/, coreAccount.synchronize()];
                case 4:
                    eventBus = _b.sent();
                    (0, logs_1.log)("libcore", "sync(".concat(logId, ") DONE coreAccount.synchronize"));
                    return [4 /*yield*/, core
                            .getThreadDispatcher()
                            .getMainExecutionContext()];
                case 5:
                    serialContext = _b.sent();
                    return [4 /*yield*/, eventBus.subscribe(serialContext, eventReceiver)];
                case 6:
                    _b.sent();
                    (0, logs_1.log)("libcore", "sync(".concat(logId, ") DONE eventBus.subscribe"));
                    _b.label = 7;
                case 7: return [4 /*yield*/, (0, buildAccount_1.buildAccount)({
                        core: core,
                        coreWallet: coreWallet,
                        coreAccount: coreAccount,
                        currency: currency,
                        accountIndex: accountIndex,
                        derivationMode: derivationMode,
                        seedIdentifier: seedIdentifier,
                        existingAccount: existingAccount,
                        logId: logId,
                        syncConfig: syncConfig
                    })];
                case 8:
                    account = _b.sent();
                    return [2 /*return*/, account];
                case 9:
                    e_1 = _b.sent();
                    specificError = (0, errors_2.remapLibcoreErrors)(e_1);
                    if (specificError.name !== "Error")
                        throw specificError;
                    throw new errors_1.SyncError(specificError.message);
                case 10: return [2 /*return*/];
            }
        });
    });
}
exports.syncCoreAccount = syncCoreAccount;
var defaultPostSyncPatch = function (initial, synced) {
    return synced;
};
function sync(existingAccount, syncConfig) {
    var logId = (0, exports.newSyncLogId)();
    var derivationMode = existingAccount.derivationMode, seedIdentifier = existingAccount.seedIdentifier, currency = existingAccount.currency;
    var postSyncPatch = libcore_postSyncPatch_1["default"][currency.family] || defaultPostSyncPatch;
    return (0, rxjs_1.defer)(function () {
        return (0, rxjs_1.from)((0, access_1.withLibcore)(function (core) {
            (0, logs_1.log)("libcore", "sync(".concat(logId, ") started. ").concat(existingAccount.id));
            return (0, getCoreAccount_1.getCoreAccount)(core, existingAccount).then(function (_a) {
                var coreWallet = _a.coreWallet, coreAccount = _a.coreAccount, walletName = _a.walletName;
                return syncCoreAccount({
                    core: core,
                    coreWallet: coreWallet,
                    coreAccount: coreAccount,
                    walletName: walletName,
                    currency: currency,
                    accountIndex: existingAccount.index,
                    derivationMode: derivationMode,
                    seedIdentifier: seedIdentifier,
                    existingAccount: existingAccount,
                    logId: logId,
                    syncConfig: syncConfig
                });
            });
        }));
    }).pipe((0, operators_1.map)(function (syncedAccount) { return function (initialAccount) {
        return (0, account_1.recalculateAccountBalanceHistories)(postSyncPatch(initialAccount, __assign(__assign({}, initialAccount), { 
            // FIXME, the "patching" logic should be somewhere else, especially that it's also in jsHelpers
            id: syncedAccount.id, freshAddress: syncedAccount.freshAddress, freshAddressPath: syncedAccount.freshAddressPath, balance: syncedAccount.balance, balanceHistory: syncedAccount.balanceHistory, spendableBalance: syncedAccount.spendableBalance, blockHeight: syncedAccount.blockHeight, lastSyncDate: new Date(), creationDate: syncedAccount.creationDate, operations: syncedAccount.operations, operationsCount: syncedAccount.operations.length, subAccounts: syncedAccount.subAccounts, pendingOperations: initialAccount.pendingOperations.filter(function (op) {
                return (0, account_1.shouldRetainPendingOperation)(syncedAccount, op);
            }), cosmosResources: syncedAccount.cosmosResources, algorandResources: syncedAccount.algorandResources, bitcoinResources: syncedAccount.bitcoinResources })), initialAccount);
    }; }));
}
exports.sync = sync;
//# sourceMappingURL=syncAccount.js.map